import {Dropdown} from 'bootstrap';

export const sortArtists = () => {

  // if ($('body').hasClass('template-itg-expositions')) {
    let dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
    dropdownElementList.map(function (dropdownToggleEl) {
      return new Dropdown(dropdownToggleEl);
    });
  // }

}
